import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";

function init() {
    $(document).on("click", "#addRegionbtn", function() {
        const $addRegionBtn = $(this);
        
        if (!$("#addRegionSelect").val()) {
            $("#regionError").removeClass("hidden");
        } else {
            $addRegionBtn.prop("disabled", true);
            
            const regionId = $("#addRegionSelect").val();
            const personId = $("#personId").val();
            const container = $("#regions");
            const data = {
                regionId: regionId,
                personId: personId
            };

            const link = {
                "url": "/api/region/personregionexists/" + personId + "/" + regionId
            };

            dataaccess.get(link).done(function(results) {
                if (!results) {
                    const params = {
                        "data": data,
                        "url": "/api/region/addregion",
                        "successMsg": "Successfully assigned region."
                    };
                    $("#addPersonRegion .close").click();
                    dataaccess.post(params).done(function(data) {
                        container.html(data);
                        $addRegionBtn.prop("disabled", false);
                    });
                } else {
                    services.notificationService.error("This region has already been assigned.");
                    $addRegionBtn.prop("disabled", false);
                }
            });
        }
    });
}

export const addRegion = {
    init: init
};